import { IMAGES } from "@/lib/brand";
import { useReveal } from "@/lib/useReveal";

export default function Products() {
  const r = useReveal();
  return (
    <section
      id="produse"
      data-testid="products-section"
      className="py-24 sm:py-32 bg-[#F5E6D3]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 grid lg:grid-cols-12 gap-12 items-center">
        <div ref={r.ref} className={`lg:col-span-6 space-y-7 ${r.className}`}>
          <div className="section-label">Produse premium</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#3B2A22] leading-[1.05]">
            Produse de top pentru rezultate{" "}
            <em className="italic text-[#B88746]">excepționale</em>
          </h2>

          <div className="space-y-6 pt-4">
            <div className="border-l-2 border-[#B88746] pl-5 py-1">
              <h3 className="font-serif text-2xl text-[#3B2A22] mb-1">Norvell</h3>
              <p className="text-sm text-[#3B2A22]/75 leading-relaxed">
                Brand profesional recunoscut internațional pentru bronzuri naturale și
                rezistență excelentă.
              </p>
            </div>
            <div className="border-l-2 border-[#B88746] pl-5 py-1">
              <h3 className="font-serif text-2xl text-[#3B2A22] mb-1">Sjolie</h3>
              <p className="text-sm text-[#3B2A22]/75 leading-relaxed">
                Formule premium pentru un bronz uniform și un aspect impecabil.
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="img-zoom rounded-[2rem] overflow-hidden border border-[#D7B899]/40 bg-[#FFFDF9]">
            <img
              src={IMAGES.products}
              alt="Produse premium Norvell și Sjolie"
              className="w-full h-auto block"
              data-testid="products-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
